<template>
  <v-card flat class="py-3 pt-6">
    <template v-if="!institutionIsConsortium">
      <v-tabs
          v-model="tabModel"
          vertical
          hide-slider
          class="publisher-setup-tab-tabs"
      >
        <v-subheader class="">
          {{ $t('setup.requiredData') }}
        </v-subheader>
        <v-divider/>
        <template v-for="tab in tabs">
          <v-subheader class="mt-" v-if="tab.isFirstRecommendedTab">
            <span style="color: #bbb;" v-if="!publisherRequiredDataIsLoaded">
            {{ $t('setup.recommendedData') }}
            </span>
            <span v-if="publisherRequiredDataIsLoaded">
            {{ $t('setup.recommendedData') }}
            </span>
          </v-subheader>
          <v-subheader class="mt-" v-if="tab.isOptional">
            <span style="color: #bbb;" v-if="!publisherRequiredDataIsLoaded">
            {{ $t('setup.optionalData') }}
            </span>
            <span v-if="publisherRequiredDataIsLoaded">
            {{ $t('setup.optionalData') }}
            </span>
          </v-subheader>
          <v-subheader class="mt-" v-if="tab.isDiagnostic">
            <span style="color: #bbb;" v-if="!publisherRequiredDataIsLoaded">
            {{ $t('setup.diagnosticData') }}
            </span>
            <span v-if="publisherRequiredDataIsLoaded">
            {{ $t('setup.diagnosticData') }}
            </span>
          </v-subheader>
          <v-tab
              class="body-1"
              :disabled="tab.isDisabled"
              :key="'tab-'+tab.id"
          >
            <v-icon
                small
                left
                v-if="tab.isWarning"
                :color="(tab.isDisabled) ? 'grey' : 'warning'"
            >
              mdi-alert
            </v-icon>
            <v-icon
                small
                left
                v-if="tab.isError"
                color="error"
            >
              mdi-close-outline
            </v-icon>
            <v-icon
                small
                left
                v-if="tab.isComplete && tab.id === 'pricelist' && journalsWithNoPriceInfo"
                color="warning"
            >
              mdi-alert
            </v-icon>
            <v-icon
                small
                left
                v-if="tab.isComplete && tab.id === 'pricelist' && !journalsWithNoPriceInfo"
                color="success"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
                small
                left
                v-if="tab.isComplete && tab.id != 'pricelist'"
                color="success"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
                small
                left
                v-if="tab.isInfo"
                :color="(tab.isDisabled) ? 'grey' : 'info'"
            >
              mdi-information
            </v-icon>
            <v-icon
                small
                left
                v-if="tab.isDiagnostic"
                :color="(tab.isDisabled) ? 'grey' : 'info'"
            >
              mdi-stethoscope
            </v-icon>
            {{ tabShortName(tab) }}
          </v-tab>

        </template>

        <v-divider/>


        <v-tab-item
            v-for="tab in tabs"
            :key="'tab-content-'+tab.id"
        >
          <div class="header">
            <div class="main-title" v-if="tab.id != 'excluded'">
              {{ $t('setup.setupPrefix') }}
              <strong>
                {{ tabLongName(tab) }}
              </strong>
              <v-btn small icon
                     :href="tab.warningUrl"
                     target="_blank"
              >
                <v-icon small>mdi-help-circle-outline</v-icon>
              </v-btn>
            </div>
            <div class="main-title" v-if="tab.id === 'excluded'">
              <strong>
                {{ tabLongName(tab) }}
              </strong>
              <v-btn small icon
                     :href="tab.warningUrl"
                     target="_blank"
              >
                <v-icon small>mdi-help-circle-outline</v-icon>
              </v-btn>
            </div>
            <v-spacer/>
          </div>
          <publisher-warning
              :id="tab.id"
              :is-required="tab.isRequired"
              :is-success="tab.isComplete"
              :url="tab.helpUrl"
              :msg="tab.alertMsg"
              :journals="tab.journals"
            />

          <publisher-setup-tab-counter  v-if="tab.id==='counter'" />
          <publisher-setup-tab-currency v-if="tab.id==='currency'" />
          <publisher-setup-tab-big-deal-costs v-if="tab.id==='bigDealCosts'" />
          <publisher-setup-tab-pta v-if="tab.id==='pta'" />
          <publisher-setup-tab-price  v-if="tab.id==='pricelist'" />
          <publisher-setup-tab-filter  v-if="tab.id==='filter'" />
          <publisher-setup-tab-excluded  v-if="tab.id==='excluded'" />
        </v-tab-item>
      </v-tabs>
    </template>
    <template v-if="institutionIsConsortium">
      <v-alert
          type="info"
          text
          outlined
          icon="mdi-information-outline"
      >
        {{ $t('setup.consortiumSetupNote') }}
        <a href="mailto:support@openalex.org">support@openalex.org</a>.
      </v-alert>
    </template>


  </v-card>


</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'

import PublisherSetupTabCounter from "../PublisherSetupTab/PublisherSetupTabCounter";
import PublisherSetupTabCurrency from "@/components/PublisherSetupTab/PublisherSetupTabCurrency";
import PublisherSetupTabPta from "@/components/PublisherSetupTab/PublisherSetupTabPta";
import PublisherSetupTabFilter from "@/components/PublisherSetupTab/PublisherSetupTabFilter";
import PublisherSetupTabExcluded from "@/components/PublisherSetupTab/PublisherSetupTabExcluded";
import PublisherSetupTabPrice from "@/components/PublisherSetupTab/PublisherSetupTabPricelist";
import PublisherSetupTabBigDealCosts from "@/components/PublisherSetupTab/PublisherSetupTabBigDealCosts";

import PublisherWarning from "@/components/PublisherWarning/PublisherWarning";


export default {
  name: "PublisherSetupTab",
  components: {

    PublisherSetupTabCounter,
    PublisherSetupTabCurrency,
    PublisherSetupTabPta,
    PublisherSetupTabFilter,
    PublisherSetupTabExcluded,
    PublisherSetupTabPrice,
    PublisherSetupTabBigDealCosts,
    PublisherWarning,
  },
  props: {},
  data() {
    return {
      tabModel: 0,
    }
  },
  methods: {
    disableTab(tabName) {
      if (tabName !== "COUNTER" && this.getPublisherWarning("missingCounterData")) {
        return true
      }
    },
    tabShortName(tab) {
      const map = {
        counter: 'setup.tabCounter',
        pricelist: 'setup.tabPricelist',
        currency: 'setup.tabCurrency',
        bigDealCosts: 'setup.tabBigDealCosts',
        pta: 'setup.tabPta',
        filter: 'setup.tabFilter',
        excluded: 'setup.tabExcludedTitles',
      }
      return map[tab.id] ? this.$t(map[tab.id]) : tab.id
    },
    tabLongName(tab) {
      const map = {
        counter: 'setup.tabCounter',
        pricelist: 'setup.tabPricelistLong',
        currency: 'setup.tabCurrency',
        bigDealCosts: 'setup.tabBigDealCosts',
        pta: 'setup.tabPtaLong',
        filter: 'setup.tabFilterLong',
        excluded: 'setup.tabExcludedTitles',
      }
      return map[tab.id] ? this.$t(map[tab.id]) : tab.id
    },
    getErrorMsg(id) {
      const msgs = {
        counter: this.$t('setup.missingData'),
        currency: this.$t('setup.missingData'),
        bigDealCosts: this.$t('setup.missingData'),
        pta: this.$t('setup.ptaMissingWarning'),
        filter: this.$t('setup.filterOptionalMsg'),
        excluded: this.$t('setup.excludedDiagnosticMsg'),
      }
      return msgs[id] || ''
    },
  },
  computed: {
    ...mapGetters([
      "publisherName",
      "publisherId",
      "publisherBigDealCost",
      "publisherFiles",
      "publisherWarnings",
      "institutionIsConsortium",
      "getPublisherWarning",
      "publisherRequiredDataIsLoaded",
      "getPublisherDataIsComplete",
      "publisherPriceDataFileIsLive",
    ]),
    tabsConfig() {
      return [
        {
          id: "counter",
          isRequired: true,
          warningUrl: this.$docsUrl('how-to-guides/upload-counter-usage-data'),
          helpUrl: this.$docsUrl('how-to-guides/upload-counter-usage-data'),
        },
        {
          id: "pricelist",
          warningId: "missingPrices",
          isRequired: true,
          warningUrl: this.$docsUrl('how-to-guides/upload-title-prices'),
          helpUrl: this.$docsUrl('troubleshooting/what-does-the-missing-prices-warning-mean'),
        },
        {
          id: "currency",
          isRequired: true,
          warningUrl: this.$docsUrl('how-to-guides/set-currency'),
          helpUrl: this.$docsUrl('how-to-guides/set-currency'),
        },
        {
          id: "bigDealCosts",
          isRequired: true,
          warningUrl: this.$docsUrl('how-to-guides/set-big-deal-costs'),
          helpUrl: this.$docsUrl('how-to-guides/set-big-deal-costs'),
        },
        {
          id: "pta",
          warningId: "missingPerpetualAccess",
          isFirstRecommendedTab: true,
          isRecommended: true,
          warningUrl: this.$docsUrl('how-to-guides/upload-pta-data'),
          helpUrl: this.$docsUrl('troubleshooting/what-does-the-missing-pta-warning-mean'),
        },
        {
          id: "filter",
          isOptional: true,
          warningUrl: this.$docsUrl('how-to-guides/upload-journal-filter'),
          helpUrl: this.$docsUrl('troubleshooting/what-does-the-journal-whitelist-alert-mean'),
        },
        {
          id: "excluded",
          isDiagnostic: true,
          warningUrl: this.$docsUrl('how-to-guides/excluded-titles-report'),
        },
      ]
    },

    tabs() {

      const ret = this.tabsConfig.map(tabConfig => {
        const isComplete = this.getPublisherDataIsComplete(tabConfig.id)
        const isError = !isComplete && tabConfig.isRequired
        const isWarning = !isComplete && tabConfig.isRecommended
        const isInfo = !isComplete && tabConfig.isOptional
        const isDisabled = !this.publisherRequiredDataIsLoaded && (tabConfig.isRecommended || tabConfig.isOptional || tabConfig.isDiagnostic)

        const myErrorMsg = (tabConfig.id === "pricelist") ? this.priceListErrorMsg : this.getErrorMsg(tabConfig.id)
        const journals = (tabConfig.id === "pricelist") ? this.journalsWithNoPrices : null

        const alertMsg = (isComplete && tabConfig.id != "pricelist") ? this.successMsg : myErrorMsg

        return {
          ..._.cloneDeep(tabConfig),
          isComplete,
          isError,
          isWarning,
          isInfo,
          isDisabled,
          alertMsg,
          journals,
        }

      })

      return ret
    },
    successMsg(){
      return this.$t('setup.fullyLoaded')
    },
    priceListErrorMsg(){
      if (this.publisherPriceDataFileIsLive && !this.journalsWithNoPriceInfo) {
        return this.$t('setup.missingPricesNone')
      } else {
        if (!this.journalsWithNoPriceInfo) return this.$t('setup.missingData')
        const prefix = (this.publisherPriceDataFileIsLive) ?
          this.$t('setup.missingPricesStill') :
          this.$t('setup.missingPricesRequired')
        return `${prefix} ${this.journalsWithNoPrices?.length}${this.$t('setup.missingPricesSuffix')}`
      }
    },
    journalsWithNoPrices(){
      return this.getPublisherWarning("missingPrices")?.journals
    },
    journalsWithNoPriceInfo(){
      return !!this.getPublisherWarning("missingPrices")?.journals.length || false
    }
  },
  created() {
  },
  mounted() {
  },
  watch: {}
}
</script>

<style lang="scss">

.setup-subtab-content {
  margin-top: 36px;
}

.publisher-setup-tab-tabs {
  .header {
    display: flex;
    align-content: flex-end;
    align-items: flex-end;
    //border-bottom: 1px solid #ddd;
    padding-bottom: 4px;
    margin-right: 30px;
    font-weight: bold;

    .main-title {
      font-size: 20px;
      font-size: 24px;
    }
  }

  .v-tabs-items {
    margin-left: 70px;
    margin-top: 15px;
  }

  .v-tabs-bar__content {
    align-items: flex-start !important;

    .v-subheader {
      font-weight: bold;
      align-items: flex-end;
      padding-bottom: 5px;
      //border-bottom: 1px solid #ddd;
      width: 100%;

    }

    .v-tab {
      padding-right: 70px;
      width: 100%;
      text-transform: capitalize;
      justify-content: left;
      //border-radius: 5px;
      //color: #333 !important;
    }

    .v-tab--active {
      font-weight: bold;
      background: #E4F3FE;
    }

    //border-right: 1px solid #ddd;
  }

  .v-tab {
    //color: #333 !important;
  }

}


</style>
